import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import { textToVoiceService } from '../../utils/text-to-voice';
import { Stop, SpeakerSlash, SpeakerHigh,SpeakerLow, Pause, Play } from 'phosphor-react';

window.Buffer = window.Buffer || require("buffer").Buffer;

const formWaveSurferOptions = ref => ({
  container: ref,
  waveColor: "#cce6ff",
  progressColor: "Blue",
  cursorColor: "Blue",
  barWidth: 3,
  barRadius: 3,
  responsive: true,
  height: 45,
  overFlow:"hidden",
  // If true, normalize by the maximum peak instead of 1.0.
  normalize: true,
  // Use the PeakCache to improve rendering speed of large waveforms.
  partialRender: true
});

// eslint-disable-next-line react/prop-types
export default function WaveformMic({ url,disc,langg }) {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [playing, setPlay] = useState(false);
  const [volume, setVolume] = useState(0.5);
  const [audioSrc, setAudioSrc] = useState(undefined);
  const [buf, setBuf] = React.useState();
  const [getLanguageCode, setLanguageCode] = React.useState();
  

  const textToSpeechFun = async () => {
    // TextToSpeech(value, textLang);
    const langCode = localStorage.getItem('selectedLang');
    const langVoice = localStorage.getItem('selectedVoice');
    setLanguageCode(langCode);
    // const { voice, text } = textLang;
    let post = {
      Body: disc,
      language: langCode,
       voice: langVoice,
    };
    let txtAudioBuffer = await textToVoiceService(post);
    // setIsLoading(false);
    console.log(txtAudioBuffer, 'aud received');
    // (txtAudioBuffer);
    let blob = new Blob([txtAudioBuffer], { type: 'audio/wav' });
    setBuf(blob);
    let url = URL.createObjectURL(blob);
    setAudioSrc(url);
    if (txtAudioBuffer.length <= 44) {
      alert('No content available!');
      return false;
    }
  };

  // create new WaveSurfer instance
  // On component mount and when url changes
  useEffect(() => {
    
   if(audioSrc !== undefined) {
    setPlay(true);

    const options = formWaveSurferOptions(waveformRef.current);
    wavesurfer.current = WaveSurfer.create(options);

    wavesurfer.current.loadBlob(buf); 

    wavesurfer.current.on("ready", function() {
      // https://wavesurfer-js.org/docs/methods.html
      // wavesurfer.current.play();
      // setPlay(true);
       wavesurfer.current.playPause();
      // make sure object stillavailable when file loaded
      if (wavesurfer.current) {
        wavesurfer.current.setVolume(volume);
        setVolume(volume);
      }
    });

    // Removes events, elements and disconnects Web Audio nodes.
    // when component unmount
    return () => wavesurfer.current.destroy();
   }
  }, [audioSrc]);

  const handlePlayPause = async() => {
      setPlay(!playing);
      if(audioSrc === undefined || getLanguageCode !== langg)
      {
      await textToSpeechFun()
      }
       wavesurfer.current.playPause();
  };

  const onVolumeChange = e => {
    const { target } = e;
    const newVolume = +target.value;

    if (newVolume) {
      setVolume(newVolume);
      wavesurfer.current.setVolume(newVolume || 1);
    }
  };

  return (
    <div>    
      <div id="waveform" ref={waveformRef} />
      <div className="controls voicecontrol">
        <button className="iconbtn" onClick={handlePlayPause}>{!playing ? <Play size={20}/> : <Pause size={20}/>}</button>
        <input
          type="range"
          id="volume"
          name="volume"
          // waveSurfer recognize value of `0` same as `1`
          //  so we need to set some zero-ish value for silence
          min="0.01"
          max="1"
          step=".025"
          onChange={onVolumeChange}
          defaultValue={volume}
        />
        <label htmlFor="volume"><b>{volume < 0.1 ? <SpeakerLow size={20}/>: <SpeakerHigh size={20} /> }</b></label>
      </div>
    </div>
  );
}
